'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeSelectable = exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _jssThemeReactor = require('jss-theme-reactor');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _ListItem = require('./ListItem');

var _ListItem2 = _interopRequireDefault(_ListItem);

var _SearchListItem = require('./SearchListItem');

var _SearchListItem2 = _interopRequireDefault(_SearchListItem);

var _PropTypes = require('../utils/PropTypes');

var _PropTypes2 = _interopRequireDefault(_PropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('SelectableList', function (theme) {
  return {
    selected: {
      backgroundColor: theme.palette.text.divider
    }
  };
});

var makeSelectable = function makeSelectable(MyComponent) {
  var _class, _temp2;

  return _temp2 = _class = function (_Component) {
    _inherits(_class, _Component);

    function _class() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, _class);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = _class.__proto__ || Object.getPrototypeOf(_class)).call.apply(_ref, [this].concat(args))), _this), _this.extendChild = function (child) {
        var _ref2 = child || {},
            _ref2$type = _ref2.type;

        _ref2$type = _ref2$type === undefined ? {} : _ref2$type;
        var muiName = _ref2$type.muiName;


        if (!(muiName === _ListItem2['default'].muiName || muiName === _SearchListItem2['default'].muiName)) {
          return;
        }

        var selectedItemStyle = _this.props.selectedItemStyle;

        var childIsSelected = _this.isChildSelected(child, _this.props);

        var classes = _this.context.styleManager.render(styleSheet);
        var selectedClass = (0, _classnames2['default'])(classes.selected);

        var mergedChildrenStyles = Object.assign({}, child.props.style, childIsSelected ? selectedItemStyle : {});
        var mergedChildrenClasses = (0, _classnames2['default'])(child.props.className, _defineProperty({}, selectedClass, childIsSelected && !selectedItemStyle));

        return _react2['default'].cloneElement(child, {
          onClick: function () {
            function onClick(event) {
              _this.handleItemClick(event, child);
              if (child.props.onClick) {
                child.props.onClick(event);
              }
            }

            return onClick;
          }(),
          style: mergedChildrenStyles,
          className: mergedChildrenClasses
        });
      }, _this.handleItemClick = function (event, item) {
        var itemValue = item.props.value;

        if (itemValue !== _this.props.value) {
          if (_this.props.onChange) {
            _this.props.onChange(event, itemValue);
          }
        }
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(_class, [{
      key: 'isChildSelected',
      value: function () {
        function isChildSelected(child, props) {
          return props.value === child.props.value;
        }

        return isChildSelected;
      }()
    }, {
      key: 'render',
      value: function () {
        function render() {
          var _this2 = this;

          var _props = this.props,
              children = _props.children,
              selectedItemStyle = _props.selectedItemStyle,
              other = _objectWithoutProperties(_props, ['children', 'selectedItemStyle']);

          return _react2['default'].createElement(
            MyComponent,
            _extends({}, other, this.state),
            _react.Children.map(children, function (child) {
              return _this2.extendChild(child);
            })
          );
        }

        return render;
      }()
    }]);

    return _class;
  }(_react.Component), _class.propTypes = {
    children: _PropTypes2['default'].node,
    onChange: _PropTypes2['default'].func,
    selectedItemStyle: _PropTypes2['default'].object,
    value: _PropTypes2['default'].any
  }, _class.contextTypes = {
    styleManager: _PropTypes2['default'].styleManager.isRequired
  }, _class.displayName = 'makeSelectable', _temp2;
};

exports.makeSelectable = makeSelectable;
exports['default'] = makeSelectable;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/List/makeSelectable.js
// module id = 1853
// module chunks = 32